/**
 * Enum representing various fixed time intervals.
 */
export enum TimeIntervalEnum {
	FIFTEEN_MINUTES = '15m',
	THIRTY_MINUTES = '30m',
	FORTY_FIVE_MINUTES = '45m',
	ONE_HOUR = '1h',
	TWO_HOURS = '2h',
	THREE_HOURS = '3h',
	FOUR_HOURS = '4h',
	SIX_HOURS = '6h',
	EIGHT_HOURS = '8h',
	TWELVE_HOURS = '12h',
	ONE_DAY = '1d',
	TWO_DAYS = '2d',
	THREE_DAYS = '3d',
	FOUR_DAYS = '4d',
	ONE_WEEK = '1w',
	TWO_WEEKS = '2w',
	THREE_WEEKS = '3w',
	FOUR_WEEKS = '4w',
}
